import api from "./axios";
import type {
    SuperAdminDashboardData,
    AdministratorDashboardData,
    TeacherDashboardData,
    StudentDashboardData,
} from "@/types/dashboard";

class DashboardService {
    // API methods with fallback to mock data
    async getSuperAdminDashboard(): Promise<SuperAdminDashboardData> {
        const response = await api.get("/v1/dashboard/super-admin");

        if (!response.data.success) {
            throw new Error(
                response.data.message ||
                    "Failed to load super-admin dashboard data",
            );
        }

        return response.data.data;
    }

    async getAdministratorDashboard(): Promise<AdministratorDashboardData> {
        const response = await api.get("/v1/dashboard/administrator");

        if (!response.data.success) {
            throw new Error(
                response.data.message ||
                    "Failed to load administrator dashboard data",
            );
        }

        return response.data.data;
    }

    async getTeacherDashboard(): Promise<TeacherDashboardData> {
        const response = await api.get("/v1/dashboard/teacher");

        if (!response.data.success) {
            throw new Error(
                response.data.message ||
                    "Failed to load teacher dashboard data",
            );
        }

        return response.data.data;
    }

    async getStudentDashboard(): Promise<StudentDashboardData> {
        const response = await api.get("/v1/dashboard/student");

        if (!response.data.success) {
            throw new Error(
                response.data.message ||
                    "Failed to load student dashboard data",
            );
        }

        return response.data.data;
    }

    // Generic dashboard data based on user role
    async getDashboardData(role: string): Promise<any> {
        switch (role) {
            case "super-administrator":
                return this.getSuperAdminDashboard();
            case "administrator":
                return this.getAdministratorDashboard();
            case "teacher":
                return this.getTeacherDashboard();
            case "student":
                return this.getStudentDashboard();
            default:
                throw new Error(`Unknown role: ${role}`);
        }
    }
}

export default new DashboardService();
